import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { SkeletonSizeBase } from '../../../common';
import { Grid, GridCols } from '../../../common/Models/Models';

@Component({
  selector: 'skc-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.less']
})
export class GridComponent extends SkeletonSizeBase implements OnInit, AfterViewInit, OnChanges {
  @Input('skc-grid') grid: Grid;
  @ViewChild('grid') gridElement;
  currentGrid = { cols: [] };
  colWidth;
  gridPadding = 8;

  constructor() {
    super();
  }

  ngOnInit() {
    this.currentGrid.cols = Object.assign([], this.grid.cols);
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.calcColumnsWidth();
    this.calcRowsHeight();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calcColumnsWidth();
      this.calcRowsHeight();
    });
  }

  private calcColumnsWidth() {
    const gridWidth = this.gridElement.nativeElement.offsetWidth - 9 * this.grid.cols.length;
    this.colWidth = gridWidth / this.grid.cols.length;
  }
  private calcRowsHeight() {
    let gridHeight = this.height;
    if (!this.height) {
      gridHeight = this.findHeight();
    }
    this.currentGrid = { cols: [] };
    this.grid.cols.forEach((c, index) => {
      const row: GridCols = { rows: [] };
      let rowSum = 0;
      for (let r of c.rows) {
        if (r === 0) {
          continue;
        }
        let calculatedHeight = (gridHeight * r) / 100 - this.gridPadding;
        if (rowSum + r > 100) {
          r = 100 - rowSum;
          if (r > 0) {
            calculatedHeight = (gridHeight * r) / 100 - this.gridPadding;
            row.rows = [...row.rows, calculatedHeight];
            rowSum += r;
          }
          break;
        } else {
          row.rows = [...row.rows, calculatedHeight];
          rowSum += r;
        }
      }
      if (rowSum < 100) {
        const remainingGrid = 100 - rowSum;
        row.rows[row.rows.length - 1] = row.rows[row.rows.length - 1] + (gridHeight * remainingGrid) / 100;
        this.currentGrid.cols = [...this.currentGrid.cols, row];
      } else {
        this.currentGrid.cols = [...this.currentGrid.cols, row];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.grid && !changes.grid.firstChange) {
      this.calcColumnsWidth();
      this.calcRowsHeight();
    }
  }

  private findHeight() {
    let gridHeight = this.gridElement.nativeElement.closest('skc-gallery').parentElement.offsetHeight;
    if (gridHeight <= 0) {
      gridHeight = this.gridElement.nativeElement.offsetHeight;
    }
    return gridHeight;
  }

  private sum(rows: number[]) {
    if (rows.length === 0) {
      return 0;
    }
    return rows.reduce((a, b) => a + b);
  }
}
